import { IOfferSpendByOfferScopeListTableLang } from '../../../types/lang'

export const offerSpendByOfferScopeListTableLang: IOfferSpendByOfferScopeListTableLang = {
	offer_spend_by_offer_scope_list_table: {
		column_scope_id: 'Scope ID',
		column_scope: 'Scope',
		column_scope_in_group: 'Scope in Group',
		column_amount: 'Amount',
		column_date: 'Date',
	}
}